import { useLocation } from "react-router-dom";
import { useAdminMode } from "@/lib/adminState";
import { AD_CONFIG, isAdminRoute } from "@/lib/ads";

export const DirectAdLink = ({ children, className = "" }) => {
  const { pathname } = useLocation();
  const adminMode = useAdminMode();
  if (adminMode || isAdminRoute(pathname)) return null;
  return (
    <a
      href={AD_CONFIG.directLink}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-xr-ad="direct-link"
      className={className}
    >
      {children}
    </a>
  );
};

export default DirectAdLink;
